export interface ISelectOption {
  label: string;
  value: string | number | { id: string };
  link?: string;
  imgUrl?: string;
  disabled?: boolean;
  create?: boolean;
}

export function optionKey(value: ISelectOption["value"]): string | number {
  if (value && typeof value === "object") {
    return value.id || "";
  }
  return value;
}
